import * as React from "react";
import {INPUT_TYPE, StyleType} from "utils/variables";
import {FIELD_NAMES} from "profile/enums";
import {TextField} from "web-com";
import {IErrors, IReferences} from "IncompleteInfoV2/References";

interface IProps {
    profile: IReferences;
    errors?: string;
    onChange: (fieldName: string, value: string) => void;
}

export const FamilyFields = (props: IProps) => {
    return <div className="family-fields-container">
      <TextField
          type={INPUT_TYPE.NUMBER}
          label="Total Dependents"
          value={props.profile[FIELD_NAMES.TOTAL_DEPENDENTS]}
          fieldName={FIELD_NAMES.TOTAL_DEPENDENTS}
          placeholder="Please enter total dependents"
          onChange={(fName, val) => props.onChange(fName, val)}
          errorMsg={props.errors || null}
          styleType={StyleType.BORDER_BOTTOM_INPUT} />
    </div>;
};

export default FamilyFields;
